import React from 'react';

interface StatCardProps {
  value: string | number;
  label: string;
  icon: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({ value, label, icon }) => {
  return (
    <div 
      className="rounded-xl p-4"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 14px 0px',
        background: 'linear-gradient(90deg, rgba(33, 33, 33, 0.92), rgba(55, 55, 55, 0.92))',
        border: '1px solid rgba(224, 224, 224, 0.13)'
      }}
    >
      <div className="flex items-center justify-between">
        <div>
          <div className="text-2xl font-normal text-brand-primary mb-2">
            {value}
          </div>
          <div className="text-gray-400 text-sm">{label}</div>
        </div>
        <div className="text-gray-200">
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
